import React from 'react';

import Button from 'common/components/Button';
import PropTypes from '../../propTypes';
import { TranslatedMessage } from 'common/components/Intl';
import * as m from '../../messages';

const ConfirmationModalContent = props => {
  return (
    <div className="ConfirmationModal__content">
      <div className="ConfirmationModal__content--top container-fluid">
        <div className="row">
          <div className="col-xs-12">
            <h3>
              <TranslatedMessage id={m.CONFIRMATION_MODAL_TITLE} />
            </h3>
            <p>
              <TranslatedMessage id={m.CONFIRMATION_MODAL_DESCRIPTION} />
            </p>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className="ConfirmationModal__data">
              <div className="text--small">
                <TranslatedMessage id={m.NAME_TITLE} />
              </div>
              <div className="text--large fs-block">{props.legalName}</div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className="ConfirmationModal__data">
              <div className="text--small">
                <TranslatedMessage id={m.DOB_TITLE} />
              </div>
              <div className="text--large fs-block">{props.formattedDob}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Button
              onClick={props.onClose}
              className="ConfirmationModal__Button button--outline"
            >
              <TranslatedMessage id={m.CANCEL} />
            </Button>
          </div>
          <div className="col-xs-12 col-sm-6">
            <Button
              onClick={props.onConfirm}
              id="confirm"
              className="ConfirmationModal__Button"
            >
              <TranslatedMessage id={m.CONFIRM} />
            </Button>
          </div>
        </div>
        <p className="ConfirmationModal__disclaimer text--small">
          <TranslatedMessage id={m.CONFIRMATION_MODAL_DISCLAIMER} />
        </p>
      </div>
    </div>
  );
};

ConfirmationModalContent.propTypes = {
  legalName: PropTypes.string.isRequired,
  formattedDob: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default ConfirmationModalContent;
